import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.promise.finally.js";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */
var deDupeAsyncFunction = function deDupeAsyncFunction(asyncFunction) {
  var inflightPromise;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            if (!inflightPromise) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", inflightPromise);

          case 3:
            inflightPromise = new Promise(function (resolve, reject) {
              asyncFunction.apply(void 0, args).then(function (result) {
                resolve(result);
              }).catch(function (error) {
                reject(error);
              }).finally(function () {
                inflightPromise = undefined;
              });
            });
            return _context.abrupt("return", inflightPromise);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export { deDupeAsyncFunction };